module.exports = __webpack_public_path__ + "0ce0b180a0543a5d0a24f958b08dfd3c.svg";